import { Link } from '@inertiajs/react';
import { cn } from '@/lib/utils';

// The upvote counter next to a project on the plain stage view. It does not vote — it
// links to the project's voting page, which is where the upvote lives.
export function LiveVoteButton({
  eventSlug,
  projectSlug,
  voted,
  count,
  size = 'md',
  fullWidth = false,
  showLabel = false,
  className,
}: {
  eventSlug: string;
  projectSlug: string;
  voted: boolean;
  count: number;
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  showLabel?: boolean;
  className?: string;
}) {
  const dimensions =
    size === 'sm'
      ? 'h-9 px-2.5 text-xs gap-1.5'
      : size === 'lg'
        ? 'h-12 px-4 text-sm gap-3'
        : 'h-11 px-3 text-sm gap-2';

  const arrowSize =
    size === 'sm'
      ? 'text-base leading-none'
      : size === 'lg'
        ? 'text-xl leading-none'
        : 'text-lg leading-none';

  return (
    <Link
      href={`/${eventSlug}/vote/${projectSlug}`}
      aria-label="Ver proyecto"
      title="Ver proyecto"
      className={cn(
        'inline-flex items-center justify-center border-2 bg-background font-bold font-mono transition-colors',
        dimensions,
        fullWidth && 'w-full',
        voted
          ? 'border-primary bg-primary text-background hover:bg-primary/90'
          : 'border-primary/40 text-primary hover:border-primary',
        className,
      )}
    >
      <span className={arrowSize}>▲</span>
      {showLabel && (
        <span className="font-title uppercase leading-none tracking-wide">
          Ver proyecto
        </span>
      )}
      <span className="leading-none">{count}</span>
    </Link>
  );
}
